import moment from 'moment';
import { FC } from 'react';
import { Locale, useDayPicker } from 'react-day-picker';

interface YearMonthProps {
    date: Date;
    maxDate: Date;
    minDate: Date;
    localeUtil: typeof moment;
    locale: Locale;
}

const getYears = (minDate: Date, maxDate: Date) => {
    const endYear = moment(maxDate).year();
    const startYear = moment(minDate).year();

    return Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
};

const YearMonth: FC<YearMonthProps> = ({ date, maxDate, minDate, localeUtil, locale }) => {
    const dayPicker = useDayPicker();
    const years = getYears(minDate, maxDate);
    const months = localeUtil.localeData(locale.code).months();

    const handleChange = (value: string, type: 'month' | 'year') => {
        let year = date.getFullYear();
        let month = date.getMonth();

        if (type === 'year') {
            year = Number(value);
        } else {
            month = Number(value);
        }

        dayPicker.goToMonth(new Date(year, month));
    };

    return (
        <div className="daypicker-year-month">
            <select
                name="year"
                className="form-control input-sm"
                value={date.getFullYear()}
                onChange={ev => handleChange(ev.target.value, 'year')}>
                {years.map(name => (
                    <option key={name} value={name}>
                        {name}
                    </option>
                ))}
            </select>
            <select
                name="month"
                className="form-control input-sm"
                value={date.getMonth()}
                onChange={ev => handleChange(ev.target.value, 'month')}>
                {months.map((item, index) => (
                    <option key={index} value={index}>
                        {item}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default YearMonth;
